import { palette } from './palette';
import type { Palette } from './palette.type';

/**
 * We need this file to visualize the color palette in storybook
 * https://github.com/thanksben/frontend/blob/d81ca3abd7121607808f82a61ff5089bb8cdc575/packages/orion/src/lib/color-palette/color-palette.stories.mdx#L3
 */
export const paletteHSBC: Palette = {
  ...palette,
  primary: {
    main: '#DB0011',
    light: '#E90A1B',
    dark: '#BA1110',
    bg: '#FCEDEF',
  },
  secondary: {
    main: '#DB0011',
    light: '#E90A1B',
    dark: '#BA1110',
    bg: '#FCEDEF',
  },
};
